<template>
  <ContentPage :back="{ name: 'leads/choose', params: { id } }">
    <template #header>
      <div class="pl-2" style="font-size: 20px; font-weight: bold">Choose a Pro</div>
    </template>

    <div class="d-flex flex-column" style="width: 100%">
      <ProsInput
        v-if="loaded"
        no-search 
        v-model="pros" 
        :service="currentRequest.service.service_id"
        :structure_type="currentRequest.structure_type"
        :zipcode="currentRequest.zipcode"
        :excluded_ids="previous_pros"
      />
    </div>
    <Section>
      <v-btn :disabled="pros.length < 1" color="primary" @click="recommendClick">
        {{ pros.length > 0 ? 'Recommend' : 'Choose a Pro' }}
      </v-btn>
    </Section>
  </ContentPage>
</template>


<script>
  import { ContentPage, Section } from '@/components/pages'
  import { ProsInput } from '@/components/inputs'
  import { mapActions, mapGetters } from 'vuex'


  export default {
    name: 'LeadsAppend',
    
    components: { ProsInput, ContentPage, Section },

    props: ['id', 'service_id', 'zipcode'],

    data() {
      return {
        pros: [],
        loaded: false,
      }
    },

    computed: {
      ...mapGetters('customer_requests', ['currentRequest']),

      previous_pros() {
        return this.currentRequest?.blocked_ids || []
      },
    },

    methods: {
      ...mapActions('customer_requests', ['loadCurrent']),
      ...mapActions('referrals', ['setCurrentRequest', 'setCurrentPros']),

      async recommendClick() {
        this.setCurrentRequest(this.currentRequest)
        this.setCurrentPros(this.pros)
        this.$router.replace({ name: 'leads/confirm', params: { id: this.id } })
      }
    },

    async created() {
      await this.loadCurrent (this.$route.params.id)
      this.loaded = true
    }
  }
</script>